import { useCurrentStream } from '../../feature-player/hooks/player-instance/use-current-stream';

import { useEpisodeOtt } from './use-episode-ott';

export const useEpisodeCurrentStream = (contentId: string) => {
    const episodeOtt = useEpisodeOtt(contentId);

    return useCurrentStream(episodeOtt?.onlineStreams?.streams);
};
